import React from "react"
import Icon from "@kit/design/icon"

export function BandsInTownPreview() {
  return (
    <div className="flex items-center">
      <div className="w-6 h-6 flex items-center justify-center mr-4">
        <Icon name="music-note" />
      </div>
      <div>Bandsintown</div>
    </div>
  )
}
